import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import Select from "react-select";
import PaginationBar from "../../UILibrary/PaginationBar";
import { useDispatch, useSelector } from "react-redux";
import { uploadCSVWithMapping } from "../../../store/suppliersManagementSlice";
const MappingTable = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [suppliersData, setSuppliersData] = useState(location.state?.suppliers);
  const folder = useState(location.state?.folder);
  const importedFile = location.state?.importedFiles;
  const [unmappedColumns, setUnmappedColumns] = useState(0);
  const [isUnmapped, setIsUnmapped] = useState(false);
  const [fieldMappings, setFieldMappings] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.auth.id);
  const user = useSelector((state) => state.auth.userDetails.userDetails);
  const [isUploading, setIsUploading] = useState(false);

  const itemsPerPage = 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleListSuppliers = suppliersData.slice(startIndex, endIndex);
  const totalItems = suppliersData.length;

  const fieldOptions = [
    { label: "Company name", value: "companyName" },
    { label: "Industry", value: "industry" },
    { label: "Website", value: "website" },
    { label: "Email", value: "email" },
    { label: "Company size", value: "companySize" },
    { label: "Certification", value: "certification" },
    { label: "Diversity status", value: "diversityStatus" },
  ];

  const fieldValues = [
    { fieldName: "Company name", value: "companyname" },
    { fieldName: "Company type", value: "companytype" },
    { fieldName: "URL", value: "url" },
    { fieldName: "Contact Email", value: "contactemail" },
    { fieldName: "Ownership", value: "ownership" },
    { fieldName: "Certification", value: "certification" },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      display: "flex",
      height: "48px",
      width: "195px",
      alignItems: "center",
      gap: "35px",
      borderRadius: "8px",
      background: "#F7F7F7",
      borderColor: state.isFocused ? "#ccc" : "#e2e2e2",
      boxShadow: "none",
      cursor: "pointer",
      color: "#7E7E7E",
    }),

    menu: (provided) => ({
      ...provided,
      background: "#FFF",
      boxShadow: "0px 4px 9px 2px rgba(0, 0, 0, 0.10)",
      display: "inline-flex",
      width: "173px",
      padding: "5px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
      fontFamily: "Hanken Grotesk",
      fontSize: "16px",
      color: "#4A4A4A",
      borderRadius: "8px",
      zIndex: 999999,
      height: "296px",
      overflow: "hidden",
    }),

    menuList: (provided) => ({
      ...provided,
      overflow: "hidden",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: "transparent",
      color: state.isFocused ? "#7E7E7E" : "#4A4A4A",
      fontFamily: "Hanken Grotesk",
      fontSize: "16px",
      cursor: "pointer",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#7E7E7E",
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 0,
    }),

    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  const handleMappingChange = (selectedOption, fieldIndex) => {
    setFieldMappings((prev) => ({
      ...prev,
      [fieldIndex]: selectedOption,
    }));
  };

  useEffect(() => {
    const totalFields = fieldValues.length;
    const mappedFields = Object.keys(fieldMappings).length;

    const remaining = totalFields - mappedFields;
    setUnmappedColumns(remaining);
    setIsUnmapped(remaining > 0);
  }, [fieldMappings]);

  const getTypeForField = (index) => {
    const typeValues = ["Text", "Long text", "Text", "Text", "Text", "Text"];
    return typeValues[index];
  };


  const handleDone = () => {
    setIsUploading(true);
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;

    const mappingObject = {};
    Object.values(fieldMappings).forEach((field, index) => {
      mappingObject[(index + 1).toString()] = field.value;
    });

    dispatch(
      uploadCSVWithMapping({
        createdBy: buyerIdToUse,
        file: importedFile,
        map: mappingObject,
        addToFolder: folder[0]?.label,
      })
    )
      .unwrap()
      .then((res) => {
        navigate("/dashboard/management");
      })
      .catch((err) => {
        console.error("Upload error:", err);
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  return (
    <div className="m-5 bg-white rounded-xl border border-[#EBEBEB] relative overflow-visible">
      <div className="suppliers-table h-[650px]">
        <div className="flex font-semibold text-left border-b border-gray-100 px-4 py-3 bg-gray-50">
          <div className="w-1/4">Field</div>
          <div className="w-1/4">Input</div>
          <div className="w-1/4">Type</div>
          <div className="w-1/4">Mapped</div>
        </div>
        <div className="table-body text-left">
          {visibleListSuppliers.map((supplier, supplierIndex) => (
            <React.Fragment key={supplierIndex}>
              {fieldValues.map((field, index) => {
                const originalValue = supplier[field.value] || "";
                const mappedField =
                  fieldMappings[index]?.label || "Select field";

                return (
                  <div
                    key={index}
                    className={`flex items-center px-4 py-3 border-b border-gray-100 `}
                  >
                    <div className="w-1/4 text-left">
                      <Select
                        options={fieldOptions}
                        value={fieldMappings[index] || null}
                        onChange={(selectedOption) =>
                          handleMappingChange(selectedOption, index)
                        }
                        placeholder="Select field"
                        styles={{
                          ...customStyles,
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 999999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="absolute"
                        menuPlacement="auto"
                        className="text-left"
                        classNamePrefix="react-select"
                      />
                    </div>

                    <div className="w-1/4 text-left truncate">
                      {originalValue}
                    </div>

                    <div className="w-1/4 text-left">
                      {getTypeForField(index)}
                    </div>

                    <div className="w-1/4 text-left">
                      {originalValue !== "" ? (
                        <div className="flex items-center text-blue-500">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.71Z"
                              fill="#0088FF"
                            />
                          </svg>
                          <span className="ml-2">Mapped</span>
                        </div>
                      ) : (
                        <span className="text-red-500">Mapping Error</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </React.Fragment>
          ))}
        </div>
        <PaginationBar
          currentPage={currentPage}
          totalPages={Math.ceil(totalItems / itemsPerPage)}
          handlePageChange={setCurrentPage}
          paginationBarStyle={{
            position: "absolute",
            bottom: "80px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        />
      </div>
      <div className="flex justify-end p-6">
        {isUnmapped ? (
          <button className="flex justify-left items-center w-[283px] h-[36px] px-4 py-[22px] bg-orange-100 text-orange-600 rounded-md text-sm">
            {unmappedColumns > 0
              ? `You have ${unmappedColumns} column${
                  unmappedColumns > 1 ? "s" : ""
                } unmapped`
              : "Mapped successfully"}
          </button>
        ) : (
          <button className=" flex justify-left items-center gap-4 w-[283px] h-[36px] px-4 py-[22px] bg-blue-100 text-blue-600 rounded-md text-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5ZM7.072 10.71L11.39 5.312L10.61 4.688L6.928 9.289L4.32 7.116L3.68 7.884L7.072 10.71Z"
                fill="#0088FF"
              />
            </svg>
            Successfully Mapped
          </button>
        )}
        <button
          className="flex w-[180px] h-[36px] px-[20px] py-[22px] justify-center items-center gap-[10px] flex-shrink-0 rounded-[8px] bg-[#EAF524] text-black border-none ml-4 disabled:opacity-50"
          onClick={handleDone}
          disabled={isUploading}
        >
          {isUploading ? (
            <>
              <svg
                className="animate-spin h-4 w-4 text-black"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l5-5-5-5v4a12 12 0 00-12 12h4z"
                />
              </svg>
              <span>Uploading...</span>
            </>
          ) : (
            "Done"
          )}
        </button>
      </div>
    </div>
  );
};

export default MappingTable;
